module.exports = __webpack_public_path__ + "media/images/games/world_culture_awareness/11-d365066b6a02ad0adc422c1a264fb6fc.png";